<template>
  <div id="app">
    <page-top id="top" />
    <router-view class="main"/>
    <page-bottom />
  </div>
</template>

<script>
import PageTop from "./components/PageTop";
import PageBottom from "./components/PageBottom";
export default {
  name: "app",
  components: {
    PageTop,
    PageBottom
  }
};
</script>

<style lang="scss">
$primary: hsl(200, 72%, 6%);
@import "node_modules/bootstrap/scss/bootstrap";
@import url("https://fonts.googleapis.com/css?family=Open+Sans&display=swap");
@import url("https://fonts.googleapis.com/css?family=Aclonica&display=swap");
html {
  scroll-behavior: smooth;
}
.main {
  min-height: calc(100vh - 202px);
}

.footer {
  height: 60px;
}
</style>